import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'loyaltic-profile-orders',
  templateUrl: './profile-orders.component.html',
  styleUrls: ['./profile-orders.component.scss']
})
export class ProfileOrdersComponent implements OnInit {
  @Input() employeeorder: [];
  constructor() { }

  ngOnInit() {
    
  }

  toLowerCase(status: string) {
    return status.toLowerCase();
  }

}
